import { render, staticRenderFns } from "./flightReservationRefund.vue?vue&type=template&id=2570c516&scoped=true&"
import script from "./flightReservationRefund.vue?vue&type=script&lang=ts&"
export * from "./flightReservationRefund.vue?vue&type=script&lang=ts&"
import style1 from "./flightReservationRefund.vue?vue&type=style&index=1&id=2570c516&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2570c516",
  null
  
)

export default component.exports